import React from "react"

const FeatureTile = ({
  title,
  description,
  className = "",
  children,
  icon,
}) => {
  const IconComponent = icon
  return (
    <div className={`feature-tile ${className}`}>
      {icon && (
        <div className="feature-tile__icon">
          <IconComponent />
        </div>
      )}
      {title && <h3 className="h5">{title}</h3>}
      {description && <p>{description}</p>}
      {children}
    </div>
  )
}

export default FeatureTile
